import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { Subscription, Observable } from 'rxjs';

import { BadgeSectionEnum, MentionBadge, mentionBadgesSaved, MentionBadgeTypeEnum } from '../../../Mentions/components/MentionCard/mention-card.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { chartColors } from '../../../Charts/enums/chart-colors.enum';
import { Mention } from '../../../Mentions/models/mention';
import { ScrollPanelComponent } from '../../../Basic/components/ScrollPanel/scroll-panel.component';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { AddMentionsWidgetComponent } from '../../../../Monitor/Shared/components/AddMentionsWidget/add-mentions-widget.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';


@Component({
    selector: 'agpr-report-import-mention-dialog',
    templateUrl: './report-import-mention-dialog.component.html',
    styleUrls: ['./report-import-mention-dialog.component.scss'],
    standalone: false
})
export class ReportImportMentionDialogComponent extends AbstractDialogComponent implements OnInit {

    @Input()
    set reportMentions(mentions: Mention[]) {
        this._reportMentions = mentions;
        this.addedMentionNumber = mentions.length;
        this.mentionBadges = this.mentionBadges.slice();
    }
    get reportMentions() {
        return this._reportMentions;
    }
    @Input() maxSelection: number = 5;
    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;
    @Input() onlySocial: boolean = false;

    @Output() mentionsAdded: EventEmitter<Mention[]> = new EventEmitter<Mention[]>();

    @ViewChild('addMentionsWidget') addMentionsWidget: AddMentionsWidgetComponent;
    @ViewChild(ScrollPanelComponent) scrollPanel: ScrollPanelComponent;

    mentionBadges: MentionBadge[] = [
        ...mentionBadgesSaved,
        {
            type: MentionBadgeTypeEnum.MENTION_IN_REPORT,
            icon: 'fa-kit-duotone fa-agpr-check-content',
            tooltip: 'Reports.mentions.badge.inReport',
            style: {
                color: chartColors.agprBlue
            },
            section: BadgeSectionEnum.second,
            condition: (mention: Mention) => {
                return this.isInReport(mention);
            }
        }
    ];
    _reportMentions: Mention[];
    hideSlideOverlay: boolean = false;
    searchMentions: Mention[] = [];
    selectedMentions: Mention[] = [];
    addedMentionNumber: number;
    maxMentionsReached: boolean = false;
    maxMentionsAdded: boolean = false;
    subscriptions: Subscription[] = [];

    readonly buttonTypes = ButtonTypesEnum;
    readonly doneWarningHeading: string = 'Reports.importTool.warningDone';


    constructor(
        public coreDialogService: CoreDialogService
    ) {
        super(coreDialogService, 'reportImportMentionDialog');
    }

    ngOnInit(): void {
        this.addedMentionNumber = this.reportMentions.length;
    }

    /**
     * Hides the import dialog
     */
    doHide() {
        this.hideSlideOverlay = true;
        this.reset();
        this.closeDialog();
    }

    /**
     * Clears the results of the dialog, and resets the form to original values
     */
    reset() {
        if (this.addMentionsWidget.sourcePicker) {
            this.addMentionsWidget.sourcePicker.resetSourcePicker();
        }

        this.addMentionsWidget.selectNone();
    }

    /**
     * Adds the selected mentions to the report
     */
    addMentions() {
        const mentions = this.getOrderedSelectedMentions();
        this.addMentionsWidget.selectNone();
        this.mentionsAdded.emit(mentions);
        this.addedMentionNumber = this.addedMentionNumber + this.selectedMentions.length;
        this.maxMentionsAdded = this.addedMentionNumber === this.maxSelection;
    }

    /**
     * Gets all of the currently selected mentions
     *
     * @returns A list of mentions
     */
    private getOrderedSelectedMentions(): Mention[] {
        return this.searchMentions.filter(mention => this.selectedMentions.includes(mention));
    }

    isInReport(mention: Mention): boolean {
        // curated mentions should all have been saved
        return !!this.reportMentions.find(reportMention => {
            if (mention.mentionId) {
                return reportMention.mentionId === mention.mentionId;
            }

            return false;
        });
    }

    setSearchMentions(mentions: Mention[]): void {
        this.searchMentions = mentions;
    }

    setSelectedMentions(mentions: Mention[]): void {
        this.selectedMentions = mentions;
        this.maxMentionsReached = this.reportMentions.length + this.selectedMentions.length === this.maxSelection;
    }
}
